import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
var OptGroup = function (_React$Component) {
  _inherits(OptGroup, _React$Component);
  function OptGroup() {
    _classCallCheck(this, OptGroup);
    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }
  return OptGroup;
}(React.Component);
OptGroup.isSelectOptGroup = true;
export default OptGroup;